var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeechBubbleBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "621px",
    height: "583px",
    viewBox: "0 0 621 583",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 621 0 621 583 0 583"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrapped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page02-Copy-6",
    transform: "translate(-1138.000000, -416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1138.000000, 416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.872324,0 C570.794757,0 621,50.2268381 621,112.185857 L621,362.445548 C621,424.405955 570.800302,474.631405 508.872324,474.631405 L478.913299,474.625852 L478.918844,548.482236 C478.918844,567.546336 463.470117,583 444.415995,583 C435.931324,583 427.744677,579.871233 421.41964,574.216133 L310.098707,474.625852 L112.127676,474.631405 C50.2052428,474.631405 0,424.404567 0,362.445548 L0,112.185857 C0,50.22545 50.1996982,0 112.127676,0 L508.872324,0 Z",
    id: "Fill-1",
    fill: "#4241FF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TAK",
    transform: "translate(122.400000, 170.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "40.8 140 40.8 20.6 0 20.6 0 0 107.4 0 107.4 20.6 66.4 20.6 66.4 140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,140 L168.6,0 L197.4,0 L248.6,140 L221.4,140 L210.2,107.6 L155.6,107.6 L144.2,140 L117.4,140 Z M162.6,87.6 L203.2,87.6 L182.8,29.4 L162.6,87.6 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "266.6 140 266.6 0 292.2 0 292.2 56.6 344 0 375.6 0 324 55.6 377 140 345.6 140 305.6 75.2 292.2 89.8 292.2 140"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbleBlue);
export default __webpack_public_path__ + "static/media/speechBubbleBlue.f551d9c882f87d5512132e03c49d3695.svg";
export { ForwardRef as ReactComponent };